import React from 'react';

/**
 * Shared disclaimer content used across form steps
 */
export const DISCLAIMER_CONTENT = (
  <>
    All website interactions and phone calls are recorded for marketing, compliance and quality assurance purposes. By clicking the button above or by using this website, you accept and agree to our{' '}
    <a href="https://symplelending.com/terms-of-use">Terms and Conditions</a>, <a href="https://symplelending.com/esign-consent">e-Sign</a>, <a href="https://symplelending.com/arbitration-agreement">Arbitration Agreement</a> and {' '}
    <a href="https://symplelending.com/privacy-policy">Privacy Policy</a>, including the provisions regarding accepting or avoiding cookies.
  </>
);

